var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 215,
    viewBox: "0 0 401 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.482 150.294H295.809C289.911 150.294 285.13 146.196 285.13 141.14V53.0365C285.13 47.9808 289.911 43.8828 295.809 43.8828H357.481C363.38 43.8828 368.161 47.9808 368.161 53.0365V141.14C368.161 146.196 363.38 150.294 357.482 150.294Z",
    fill: "#E87F31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 96.4707H286.993V97.552H288.254V96.4707Z",
    fill: "#6B275D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 96.4707H291.979V97.552H293.24V96.4707Z",
    fill: "#6B275D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 96.4707H296.964V97.552H298.225V96.4707Z",
    fill: "#6B275D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 96.4707H301.95V97.552H303.212V96.4707Z",
    fill: "#6B275D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 96.4707H306.936V97.552H308.198V96.4707Z",
    fill: "#6B275D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 96.4707H311.922V97.552H313.184V96.4707Z",
    fill: "#6B275D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 96.4707H316.907V97.552H318.168V96.4707Z",
    fill: "#6B275D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 100.815H286.993V101.897H288.254V100.815Z",
    fill: "#6B275D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 100.815H291.979V101.897H293.24V100.815Z",
    fill: "#6B275D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 100.815H296.964V101.897H298.225V100.815Z",
    fill: "#6B275D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 100.815H301.95V101.897H303.212V100.815Z",
    fill: "#6B275D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 100.815H306.936V101.897H308.198V100.815Z",
    fill: "#6B275D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 100.815H311.922V101.897H313.184V100.815Z",
    fill: "#6B275D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 100.815H316.907V101.897H318.168V100.815Z",
    fill: "#6B275D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 105.16H286.993V106.241H288.254V105.16Z",
    fill: "#6B275D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 105.16H291.979V106.241H293.24V105.16Z",
    fill: "#6B275D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 105.16H296.964V106.241H298.225V105.16Z",
    fill: "#6B275D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 105.16H301.95V106.241H303.212V105.16Z",
    fill: "#6B275D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 105.16H306.936V106.241H308.198V105.16Z",
    fill: "#6B275D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 105.16H311.922V106.241H313.184V105.16Z",
    fill: "#6B275D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 105.16H316.907V106.241H318.168V105.16Z",
    fill: "#6B275D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 109.505H286.993V110.586H288.254V109.505Z",
    fill: "#6B275D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 109.505H291.979V110.586H293.24V109.505Z",
    fill: "#6B275D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 109.505H296.964V110.586H298.225V109.505Z",
    fill: "#6B275D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 109.505H301.95V110.586H303.212V109.505Z",
    fill: "#6B275D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 109.505H306.936V110.586H308.198V109.505Z",
    fill: "#6B275D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 109.505H311.922V110.586H313.184V109.505Z",
    fill: "#6B275D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 109.505H316.907V110.586H318.168V109.505Z",
    fill: "#6B275D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 113.85H286.993V114.931H288.254V113.85Z",
    fill: "#6B275D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 113.85H291.979V114.931H293.24V113.85Z",
    fill: "#6B275D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 113.85H296.964V114.931H298.225V113.85Z",
    fill: "#6B275D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 113.85H301.95V114.931H303.212V113.85Z",
    fill: "#6B275D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 113.85H306.936V114.931H308.198V113.85Z",
    fill: "#6B275D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 113.85H311.922V114.931H313.184V113.85Z",
    fill: "#6B275D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 113.85H316.907V114.931H318.168V113.85Z",
    fill: "#6B275D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 118.195H286.993V119.276H288.254V118.195Z",
    fill: "#6B275D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 118.195H291.979V119.276H293.24V118.195Z",
    fill: "#6B275D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M298.225 118.195H296.964V119.276H298.225V118.195Z",
    fill: "#6B275D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 118.195H301.95V119.276H303.212V118.195Z",
    fill: "#6B275D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.198 118.195H306.936V119.276H308.198V118.195Z",
    fill: "#6B275D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M313.184 118.195H311.922V119.276H313.184V118.195Z",
    fill: "#6B275D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M318.168 118.195H316.907V119.276H318.168V118.195Z",
    fill: "#6B275D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M285.13 94.5981V120.345C287.889 119.751 289.935 117.616 289.935 115.067V99.8771C289.936 97.3276 287.89 95.1928 285.13 94.5981Z",
    fill: "#6B275D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M306.105 119.4H304.003C300.491 119.4 297.645 116.96 297.645 113.951V98.7611C297.645 95.7513 300.491 93.3115 304.003 93.3115H306.105C309.616 93.3115 312.463 95.7513 312.463 98.7611V113.951C312.463 116.96 309.616 119.4 306.105 119.4Z",
    fill: "#6B275D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M339.539 92.7372C339.539 86.289 333.44 81.061 325.916 81.061C318.393 81.061 312.294 86.2882 312.294 92.7372C312.294 97.4824 315.598 101.563 320.342 103.39L313.735 122.859H337.597L331.372 103.436C336.179 101.632 339.539 97.5218 339.539 92.7372Z",
    fill: "#6B275D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.754 92.7372C313.754 86.4998 319.464 81.4194 326.647 81.0927C326.404 81.0819 326.164 81.061 325.918 81.061C318.395 81.061 312.296 86.2882 312.296 92.7372C312.296 97.4824 315.6 101.563 320.343 103.39L313.736 122.859H315.194L321.801 103.39C317.058 101.563 313.754 97.4824 313.754 92.7372Z",
    fill: "#F2BC36"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M340.998 92.7372C340.998 86.289 334.9 81.061 327.376 81.061C327.13 81.061 326.89 81.0819 326.647 81.0927C333.829 81.4194 339.54 86.4998 339.54 92.7372C339.54 97.5218 336.181 101.632 331.375 103.436L337.599 122.858H339.057L332.832 103.436C337.639 101.632 340.998 97.5218 340.998 92.7372Z",
    fill: "#F2BC36"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M360.055 145.831C361.293 145.831 362.296 144.972 362.296 143.911C362.296 142.851 361.293 141.991 360.055 141.991C358.818 141.991 357.815 142.851 357.815 143.911C357.815 144.972 358.818 145.831 360.055 145.831Z",
    fill: "#6B275D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M359.769 141.884C358.524 141.884 357.516 142.748 357.516 143.815C357.516 144.276 357.712 144.694 358.028 145.026L360.969 142.186C360.62 141.997 360.211 141.884 359.769 141.884ZM361.59 142.687L358.657 145.484C358.986 145.646 359.361 145.745 359.768 145.745C361.012 145.745 362.02 144.881 362.02 143.815C362.021 143.392 361.858 143.004 361.59 142.687Z",
    fill: "#F2BC36"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M360.969 142.186L358.028 145.027C358.203 145.211 358.414 145.367 358.657 145.485L361.59 142.687C361.423 142.488 361.212 142.318 360.969 142.186Z",
    fill: "#6B275D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M293.979 145.831C295.216 145.831 296.219 144.972 296.219 143.911C296.219 142.851 295.216 141.991 293.979 141.991C292.742 141.991 291.739 142.851 291.739 143.911C291.739 144.972 292.742 145.831 293.979 145.831Z",
    fill: "#6B275D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M293.69 141.884C292.445 141.884 291.437 142.748 291.437 143.815C291.437 144.276 291.633 144.694 291.949 145.026L294.89 142.186C294.542 141.997 294.132 141.884 293.69 141.884ZM295.512 142.687L292.579 145.484C292.908 145.646 293.283 145.745 293.69 145.745C294.934 145.745 295.942 144.881 295.942 143.815C295.942 143.392 295.78 143.004 295.512 142.687Z",
    fill: "#F2BC36"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M294.89 142.186L291.949 145.027C292.124 145.211 292.336 145.367 292.578 145.485L295.511 142.687C295.343 142.488 295.133 142.318 294.89 142.186Z",
    fill: "#6B275D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M293.979 52.6926C295.216 52.6926 296.219 51.833 296.219 50.7726C296.219 49.7122 295.216 48.8525 293.979 48.8525C292.742 48.8525 291.739 49.7122 291.739 50.7726C291.739 51.833 292.742 52.6926 293.979 52.6926Z",
    fill: "#6B275D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M293.69 48.7456C292.445 48.7456 291.437 49.6098 291.437 50.6764C291.437 51.1383 291.633 51.5561 291.949 51.8882L294.89 49.0476C294.542 48.8591 294.132 48.7456 293.69 48.7456ZM295.512 49.5488L292.579 52.3462C292.908 52.5076 293.283 52.6073 293.69 52.6073C294.934 52.6073 295.942 51.743 295.942 50.6764C295.942 50.254 295.78 49.8663 295.512 49.5488Z",
    fill: "#F2BC36"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M294.89 49.0474L291.949 51.888C292.124 52.0726 292.336 52.2278 292.578 52.346L295.511 49.5486C295.343 49.3493 295.133 49.1794 294.89 49.0474Z",
    fill: "#6B275D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M359.958 52.6926C361.195 52.6926 362.198 51.833 362.198 50.7726C362.198 49.7122 361.195 48.8525 359.958 48.8525C358.721 48.8525 357.718 49.7122 357.718 50.7726C357.718 51.833 358.721 52.6926 359.958 52.6926Z",
    fill: "#6B275D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M359.671 48.7456C358.427 48.7456 357.419 49.6098 357.419 50.6764C357.419 51.1383 357.615 51.5561 357.931 51.8882L360.872 49.0476C360.523 48.8591 360.114 48.7456 359.671 48.7456ZM361.493 49.5488L358.56 52.3462C358.888 52.5076 359.264 52.6073 359.671 52.6073C360.915 52.6073 361.923 51.743 361.923 50.6764C361.924 50.254 361.761 49.8663 361.493 49.5488Z",
    fill: "#F2BC36"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M360.871 49.0474L357.93 51.888C358.105 52.0726 358.317 52.2278 358.559 52.346L361.492 49.5486C361.324 49.3493 361.113 49.1794 360.871 49.0474Z",
    fill: "#6B275D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 94.1758V100.29L121.172 96.4951L116.963 94.1758Z",
    fill: "#EA5EA4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M102.112 103.404C102.112 102.232 101.004 101.282 99.6372 101.282H97.7126C95.9483 101.282 94.3336 100.748 93.0595 99.8672L82.9776 106.231L60.2646 99.9398L62.9371 89.8716L82.1756 78.7137L102.112 86.4339V86.4331V83.133C102.112 79.9764 102.878 76.9736 104.253 74.2496L86.4079 65.2256L38.568 77.5436L7.93742 156.474L0 194.962L53.2579 195.604L50.9783 156.492L67.8272 143.228L97.0719 118.221L102.619 113.221C102.289 111.799 102.112 110.33 102.112 108.825V103.404Z",
    fill: "#EA5EA4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 94.176L109.015 89.7969L93.0601 99.8674C94.3342 100.749 95.9489 101.282 97.7132 101.282H99.6378C101.005 101.282 102.113 102.232 102.113 103.404V108.826C102.113 110.33 102.289 111.799 102.619 113.221L116.963 100.291V94.176Z",
    fill: "#EA5EA4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8254 76.446L86.7637 53.7671L125.181 55.3766L118.356 63.8901L84.0047 65.8433L42.8254 76.446Z",
    fill: "#EA5EA4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M102.616 73.4209L100.613 76.7929L100.075 85.6439L102.113 86.4317C102.113 86.4317 101.944 82.353 102.516 79.4096C103.192 75.9341 104.254 74.2481 104.254 74.2481L102.616 73.4209Z",
    fill: "#6B275D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M47.361 76.5009L57.5781 49.7604L92.4328 34.2773L89.5089 44.3424L68.0168 55.366L66.0453 68.559L47.361 76.5009Z",
    fill: "#EA5EA4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2578 195.604L34.9582 195.384L41.2737 157.091L67.8279 143.228L50.9781 156.492L53.2578 195.604Z",
    fill: "#6B275D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2661 65.6586L86.4083 65.2253L64.673 70.8216L90.3784 60.1147L105.955 64.5958L87.2661 65.6586Z",
    fill: "#6B275D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7082 64.1188L67.1929 60.875L48.9384 72.3705L48.5005 73.5166L66.7082 64.1188Z",
    fill: "#6B275D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 54.9395L125.182 55.3766L118.357 63.89L119.923 57.8203L114.75 54.9395Z",
    fill: "#F0BBE7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4327 34.2773L80.9487 39.3786L88.7888 37.3149L89.5088 44.3424L92.4327 34.2773Z",
    fill: "#F0BBE7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M109.014 89.7959L91.04 97.7008C91.04 97.7008 91.8942 99.2029 93.0602 99.8664L109.014 89.7959Z",
    fill: "#6B275D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M113.195 64.8216L118.401 64.593L120.616 61.7075L119.965 61.8828L118.356 63.8901L114.441 64.1133L113.195 64.8216Z",
    fill: "#6B275D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M368.416 106.755L384.765 125.634L400.666 214.322H353.635L359.234 181.88L346.469 166.139L336.166 150.59H361.921L357.666 139.264L340.869 125.443L342.772 116.42L368.416 126.978V106.755Z",
    fill: "#EA5EA4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M342.649 117.005L341.765 116.74L339.302 126.082L356.471 140.863L358.505 148.253C358.785 149.273 357.883 150.25 356.661 150.251L335.949 150.261L337.09 151.983L358.712 152.252L361.549 153.786L374.314 167.226L361.922 150.589L357.667 139.263L340.87 125.442L342.649 117.005Z",
    fill: "#6B275D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M359.234 181.879L364.609 185.334L361.921 186.102L353.635 214.321L359.234 181.879Z",
    fill: "#6B275D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M367.142 126.499L374.314 129.857L371.328 124.386L369.788 108.339L368.187 106.49L368.154 126.37L367.142 126.499Z",
    fill: "#6B275D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M340.869 125.442L350.164 128.61L353.299 122.659L342.772 116.42L340.869 125.442Z",
    fill: "#F0BBE7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M110.817 105.83L108.423 101.036L113.871 92.4722L121.172 96.4953L110.817 105.83Z",
    fill: "#F0BBE7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M298.601 88.5532H263.164H257.488V86.2346C257.488 85.6314 257.365 85.0483 257.19 84.4822C256.396 81.9289 253.953 79.8845 250.793 79.6257C248.515 79.4396 246.434 80.1455 244.939 81.3728C243.528 82.5313 242.639 84.1532 242.639 85.9597V86.6077C242.639 87.682 241.623 88.5524 240.37 88.5524H214.243H171.448C169.758 88.5524 168.389 87.3785 168.389 85.9303V83.1314C168.389 70.764 156.692 60.7383 142.263 60.7383H128.238C113.81 60.7383 102.113 70.764 102.113 83.1314V86.4316C102.113 87.6032 101.005 88.5532 99.6379 88.5532H98.0331C97.3222 88.5532 96.6365 88.6598 95.9706 88.8134C93.0007 89.4985 90.6246 91.5892 90.3228 94.2924C89.9002 98.0884 93.372 101.282 97.7133 101.282H99.6379C101.005 101.282 102.113 102.232 102.113 103.404V108.825C102.113 121.193 113.81 131.219 128.238 131.219H142.263C155.79 131.219 166.916 122.407 168.254 111.115C168.343 110.362 168.389 109.598 168.389 108.825V103.904C168.389 102.456 169.758 101.282 171.448 101.282H189.295H239.752C241.346 101.282 242.639 102.39 242.639 103.757V104.257C242.639 107.581 245.474 110.549 249.334 110.866C253.763 111.228 257.489 108.252 257.489 104.532V101.283H268.076C270.279 101.283 272.064 102.813 272.064 104.7V111.616C272.064 114.94 274.899 117.908 278.759 118.224C283.188 118.586 286.914 115.611 286.914 111.89V103.673C289.768 104.025 292.66 104.111 295.44 104.03V111.616C295.44 114.94 298.274 117.908 302.135 118.225C306.564 118.587 310.29 115.611 310.29 111.891V102.184V98.5727C310.288 93.0389 305.055 88.5532 298.601 88.5532ZM142.262 118.49H128.238C122.01 118.49 116.963 114.163 116.963 108.825V106.337V83.1329C116.963 77.7953 122.01 73.4687 128.238 73.4687H142.262C148.49 73.4687 153.537 77.7953 153.537 83.1329V86.491C153.537 87.6302 152.46 88.5539 151.131 88.5539H137.908C134.03 88.5539 130.567 90.9837 130.198 94.2924C129.776 98.0884 133.247 101.282 137.589 101.282H151.133C152.462 101.282 153.539 102.206 153.539 103.345V108.825C153.539 111.288 152.455 113.529 150.685 115.236C148.619 117.228 145.616 118.49 142.262 118.49Z",
    fill: "#F2BC36"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M116.962 94.1755L109.014 89.7964L93.0592 99.8669C94.3333 100.748 95.948 101.282 97.7123 101.282H99.6369C101.004 101.282 102.112 102.232 102.112 103.403V108.825C102.112 110.33 102.288 111.799 102.619 113.221L116.962 100.29V94.1755Z",
    fill: "#EA5EA4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M109.014 89.7959L91.04 97.7008C91.04 97.7008 91.8942 99.2029 93.0602 99.8664L109.014 89.7959Z",
    fill: "#6B275D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M110.817 105.83L108.423 101.036L113.871 92.4722L121.172 96.4953L110.817 105.83Z",
    fill: "#F0BBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/open-lock.9d29a72dae33d14c0f50b79537065614.svg";
export { ForwardRef as ReactComponent };